var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9083 43.7109C22.9483 44.3777 21.0532 45.4005 21.0532 46.5495C21.0532 48.5563 26.8502 50.1844 34.0001 50.1844C41.15 50.1844 46.947 48.5563 46.947 46.5495C46.947 45.4005 45.0519 44.3777 42.0919 43.7109",
    stroke: "#2F3031",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0461 29.1475C38.0461 30.2205 37.6199 31.2496 36.8611 32.0083C36.1024 32.7671 35.0733 33.1934 34.0002 33.1934C32.9272 33.1934 31.8981 32.7671 31.1394 32.0083C30.3806 31.2496 29.9543 30.2205 29.9543 29.1475C29.9543 28.0744 30.3806 27.0453 31.1394 26.2866C31.8981 25.5278 32.9272 25.1016 34.0002 25.1016C35.0733 25.1016 36.1024 25.5278 36.8611 26.2866C37.6199 27.0453 38.0461 28.0744 38.0461 29.1475Z",
    stroke: "#2F3031",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0345 42.8952C35.4878 43.4211 34.7588 43.7149 34.0002 43.7149C33.2416 43.7149 32.5126 43.4211 31.9659 42.8952C26.9668 38.0514 20.2684 32.6413 23.5343 24.7857C25.3031 20.5375 29.5432 17.8203 34.0002 17.8203C38.4572 17.8203 42.6989 20.5392 44.4661 24.7857C47.7288 32.6299 41.0465 38.0676 36.0345 42.8952Z",
    stroke: "#2F3031",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoManagement);
export default __webpack_public_path__ + "static/media/geoManagement.d110576008848fcdc3e01f814899ba14.svg";
export { ForwardRef as ReactComponent };